import React from 'react';

import Button from '../../../../components/Button';

import './styles.css';

const PATREON_LINK = "https://www.patreon.com/baloo_org";


const Component = () => (
  <div>
    <div className="contact_sent_header">
      Message Sent!
    </div>
    <div className="contact_sent_body">
      We’re excited to speak with you! Please give us 48 hours to respond due to
      our limited resources. For the latest product updates, check out our Patreon.
    </div>
    <Button link={PATREON_LINK}>
      View Patreon
    </Button>
  </div>
);

Component.displayName = 'Sent';

export default Component;



// WEBPACK FOOTER //
// ./src/forms/Contact/components/Sent/index.js